var lib_core = require("lib-core");
var editor_2d = require("editor-2d");
var lib_geometry = require("lib-geometry");
var colors = require("../colors/colors");

/**
 * @author Ed Pataky
 * @class HandleViewOutline
 *
 * @description for shapes that use the 9-point grid, this is a class
 *   that draws an outline connecting the handles
 *
 * @param {interaction view class} view
 * @param {object} gui
 * @param {object} parentGroup
 * @param {object} interactionIndex
 * @param {object} interactionControlIndex
 */
var HandleViewOutline = function (view, gui, parentGroup, layers) {
    var self = this;
    this.gui = gui;
    this.view = view;
    this.handles = view.interactionModel.handles.toArray();

    this.cameraModel = this.gui.editorModel.cameraModel();
    this.handleModel = this.handles[0];
    this.dataModel = this.handleModel.modelData;
    this.interactionModel = this.handleModel.parent();

    // some data models do not have angles
    if (this.dataModel != undefined && this.dataModel.angle != undefined) {
        this.angle = this.dataModel.angle;
    } else {
        this.angle = null;
    }

    this.initGroups(parentGroup, [layers.interaction, layers.interactionControl], this.handleModel);

    this.svgGroup = this.getGroupInfo(layers.interaction).svgGroup;
    this.controlGroup = this.getGroupInfo(layers.interactionControl).svgGroup;

    this.cameraModel.viewS.onChange(self, function () {
        if (self.handleModel.isAlive()) self.gui.heavyHandler.scheduleHeavy('rebuild_view', self.drawIfNeeded, self, [], self);
    }, 10);
    this.handleModel.coord.onChange(self, function () {
        if (self.handleModel.isAlive()) self.gui.heavyHandler.scheduleHeavy('rebuild_view', self.drawIfNeeded, self, [], self);
    }, 10);
    this.interactionModel.infocus.onChange(self, function () {
        if (self.handleModel.isAlive()) self.gui.heavyHandler.scheduleHeavy('rebuild_view', self.drawIfNeeded, self, [], self);
    }, 10);
    if (this.angle != null) {
        this.angle.onChange(self, function () {
            if (self.handleModel.isAlive()) self.gui.heavyHandler.scheduleHeavy('rebuild_view', self.drawIfNeeded, self, [], self);
        }, 10);
    }
    this.handleModel.onDie(self, function () {
        self.emptySvgGroups();
    }, 10);

    this.drawIfNeeded();
};

lib_core.mixin(HandleViewOutline, editor_2d.DrawingElement);

module.exports = HandleViewOutline;

HandleViewOutline.prototype.drawIfNeeded = function () {
    if (this.handleModel.isAlive()
        && this.interactionModel.infocus()
        && (!this.handleModel.isHidden || !this.handleModel.isHidden())) {
        this.draw();
    } else {
        this.emptySvgGroups();
    }
};

/**
 * We draw an outline using a BoundingBox made from the model position, widht, and height
 * @author Ed Pataky
 * @function draw
 */
HandleViewOutline.prototype.draw = function () {
    var self = this;

    $(self.svgGroup).empty();
    $(self.controlGroup).empty();

    var stroke = 1 / self.cameraModel.viewS();
    var roundness = 1 / self.cameraModel.viewS();

    // get bounding box from here, seems like not correct when calling as above
    var center = this.dataModel.pos();
    var w = this.dataModel.width();
    var h = this.dataModel.height();
    var bb = new lib_geometry.BoundingBox(center.x - w / 2, center.y - h / 2, w, h);
    //bb = bb.rotate(this.dataModel.angle(), center);  DO NOT ROTATE here, done below in svg

    var centerX = bb.x + bb.width / 2;
    var centerY = bb.y + bb.height / 2;

    self.gui.svg.rect(self.svgGroup, bb.x, bb.y, bb.width, bb.height, {
        'fill': 'none',
        'stroke': colors.handleViewOutlineStroke,
        'strokeWidth': stroke,
        'transform': (self.angle != null ?
            (self.angle() ? 'rotate(' + self.angle() + ' ' + centerX + ' ' + centerY + ')' : '') : '')
    });

    // cleanup
    bb = null;
    stroke = null;
    roundness = null;
    centerX = centerY = null;
};

HandleViewOutline.prototype.clickAction = function () {
};
